
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"stroke":"#FFD250","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","d":"M17.8 13.44V9.5a.36.36 0 00-.19-.36L7.56 3.9"}}),_c('path',{attrs:{"stroke":"#000","d":"M12.23 23.5V11.83l10.18-5.5-10.18 5.5L1.59 6.36"}}),_c('path',{attrs:{"stroke":"#000","d":"M22.41 18.5v-12a.36.36 0 00-.2-.32L12.34 1.5a.34.34 0 00-.34 0L1.9 6.36a.36.36 0 00-.21.33v11.74a.36.36 0 00.21.33l10 4.68a.32.32 0 00.3 0l10-4.58a.36.36 0 00.21-.36z"}})])])
          )
        }
      }
    